import { Row } from '@opendoor/atoms/box';
import { Text } from '@opendoor/atoms/text';
import { formatCurrency } from '@opendoor/shared-fe/formatUtils';

interface PricingTraditionalProps {
  price?: number | null;
}

export const PricingTraditional = ({ price }: PricingTraditionalProps) => {
  return (
    <Row className="items-center">
      <Text as="h2" className="pb-6 text-header-md text-od-content-primary">
        {price ? formatCurrency(price) : 'Price not available'}
      </Text>
    </Row>
  );
};
